import { ReactNode } from 'react';

type ChipStyle = 'surface' | 'outlined' | 'accent';

interface ProseChipProps {
  children: ReactNode;
  style?: ChipStyle;
  icon?: ReactNode;
  className?: string;
}

const styleMap: Record<ChipStyle, string> = {
  surface: `
    bg-[var(--color-surface)] border border-[var(--color-border)]
    text-[var(--color-text)]
  `,
  outlined: `
    bg-transparent border border-[var(--color-volt)]
    text-[var(--color-volt)]
  `,
  accent: `
    bg-[var(--color-volt)] border border-transparent
    text-black
  `,
};

export function ProseChip({ children, style = 'surface', icon, className = '' }: ProseChipProps) {
  return (
    <span
      className={`
        inline-flex items-center gap-2
        py-2 px-3.5 rounded-3xl
        font-display text-sm
        transition-all duration-200
        ${styleMap[style]}
        ${className}
      `}
    >
      {icon && <span className="text-sm">{icon}</span>}
      {children}
    </span>
  );
}
